import {ApolloClient} from 'apollo-client'
import store from '@/store/index'
import 'isomorphic-unfetch'
import { GC_AUTH_TOKEN } from '@/constants/jwt'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";


// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_BACKEND_URL,
})

const middlewareLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem(GC_AUTH_TOKEN)
  if (process.env.VUE_APP_ADMIN_SECRET){
    operation.setContext({
      headers: {
        'x-hasura-admin-secret': process.env.VUE_APP_ADMIN_SECRET,
      }
    })
  } else {
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  }
  return forward(operation);
});

function omitTypename(key, value) {
  return key === '__typename' ? undefined : value
}

const omitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
  }

  return forward(operation)
})

const errorLink = onError( err => {
  if (err.response && err.response.errors && err.response.errors[0].extensions.code == "access-denied") {
    const token = localStorage.getItem(GC_AUTH_TOKEN)
    if (token) {
      const decodedToken = parseJwt(token)
      const current_time = Date.now().valueOf() / 1000;

      if (decodedToken.exp < current_time) {
        /* expired */
        store.dispatch('Auth/logout')
      } else {
        // eslint-disable-next-line
        console.error(err)
      }
    } else {
      // eslint-disable-next-line
      console.error(err)
    }
  } else {
    // eslint-disable-next-line
    console.error(err)
  }
});

const link = new ApolloLink.from([
  omitTypenameLink,
  errorLink,
  middlewareLink,
  httpLink
])

const cache = new InMemoryCache()

const client = new ApolloClient({
  // uri: 'https://cooc-admins.walkingnerds.dev/hasura/v1/graphql',
  link: link,
  cache
})

client.defaultOptions = {
  query: {
    fetchPolicy: 'no-cache'
  }
}

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

export default client